const handleVideoLoaded = (event) => {
  const video = event.target;
  const videoContainer = video && video.closest ? video.closest('[class*="video"]') : null;

  if (videoContainer) {
    videoContainer.classList.add('is-loaded');
  }

  if (video) {
    video.removeEventListener('loadeddata', handleVideoLoaded);
  }
};

export default () => {
  const videos = Array.from(document.getElementsByTagName('video'));
  if (!videos.length) {
    return;
  }

  videos.forEach((video) => {
    video.addEventListener('loadeddata', handleVideoLoaded);
  });
};
